import Head from 'next/head'
import type { NextPage } from 'next'

import RecreateSafe from '@/components/new-safe/recreate'

const Recreate: NextPage = () => {
  return (
    <main>
      <Head>
        <title>{'Safe{Wallet} - Recreate Safe Account'}</title>
      </Head>

      <RecreateSafe />
    </main>
  )
}

export default Recreate
